
// 产品档案
import request from './libs/request'
import sign from './libs/sign'
import base from './libs/base'

// 产品档案列表
const productArchives = (params={}) => {
	return request.get(`${ base.BASE_API }/product_archives`, { params: sign.main(params) })
}
// 修改记录
const editRecord = (params={}) => {
	return request.get(`${ base.BASE_API }/product_archives/edit_record`, { params: sign.main(params) })
}
// 详情
const productArchivesDetail = (params={}) => {
	return request.get(`${ base.BASE_API }/product_archives/detail`, { params: sign.main(params) })
}
// 配置信息
const getDocConfig = (params={}) => {
	return request.get(`${ base.BASE_API }/product_archives/config`, { params: sign.main(params) })
}
// 修改状态
const handleStates = (params={}) => {
	return request.put(`${ base.BASE_API }/product_archives/switch`, sign.main(params) )
}
// 新增
const addProductArchives = (params) => {
	return request.post(`${ base.BASE_API }/product_archives`, sign.main(params) )
}
// 编辑
const editProductArchives = (params) => {
	return request.put(`${ base.BASE_API }/product_archives`, sign.main(params) )
}

export {
    productArchives,
    getDocConfig,
    addProductArchives,
    editProductArchives,
    editRecord,
    productArchivesDetail,
    handleStates,
}


// WEBPACK FOOTER //
// ./src/api/productArchive.js